import * as React from "react";
import {
  ChakraProvider,
  Box,
  Grid,
  theme,
  Container,
  Flex,
} from "@chakra-ui/react";
import { ColorModeSwitcher } from "./ColorModeSwitcher";
import CheckoutForm from "./payments/CheckoutForm";

export const App = () => (
  <ChakraProvider theme={theme}>
    <Box w="100%">
      <Flex
        flexDirection="row"
        flexGrow={1}
        justifyContent="flex-end"
        padding="30px"
      >
        <ColorModeSwitcher />
      </Flex>
      <Container maxW="container.md" centerContent marginTop="0px">
        <Box fontSize="xl" minW="60%">
          <Grid minH="100vh" p={4}>
            <CheckoutForm />
          </Grid>
        </Box>
      </Container>
    </Box>
  </ChakraProvider>
);
